import { MaterialService } from './material.service';
import { ExerciceMedia } from './../model/exerciceMedia.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
@Injectable()
export class ExerciceMediaService extends KiwixiService {

    apiMedia = environment.server + 'exercices_medias/';

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,
    ) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    getYoutubeScriptContext() {
        const tag_id = 'youtube_iframe_api';
        if (!document.getElementById(tag_id)) {
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            tag.id = tag_id;
            document.body.appendChild(tag);
        }
    }

    downloadMedia(exerciceMedia : ExerciceMedia): void {
        const url = this.apiMedia + exerciceMedia.id + '/download/';
        const header = this.createHttpClientAuthorizationHeader();
        this._http.get(url, { headers: header, responseType: 'arraybuffer' })
            .subscribe(
                {
                    next: (file: ArrayBuffer) => {
                        const filename = exerciceMedia.title || 'exercice'
                        this.downloadFile(filename, file);
                    },
                    error: (err: HttpErrorResponse) => {
                        if (err.status === 400)
                            this.materialService.openSnackBar('Téléchargement impossible', 'red')
                    }
                }
            )
    }

    deleteMedia(id): Observable<ExerciceMedia> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.delete<ExerciceMedia>(this.apiMedia + id + '/', {
            headers: header,
        })
            .pipe(
                catchError(this.handleErrorObservable<ExerciceMedia>(`delete Media`))
            );
    }

    postEmbededdMedia(params): Promise<ExerciceMedia> {
        const self = this;
        const _formData = new FormData();
        _formData.append('enctype', 'multipart/form-data');
        self.headers.delete('Content-Type');
        _formData.append('media_type', params.media_type);
        _formData.append('source_type', params.source_type);
        _formData.append('content_type', params.content_type);
        _formData.append('object_id', params.entity_id);
        _formData.append('url', params.url);
        const headers = this.createHttpClientAuthorizationHeaderNoEnctype();
        return self._http.post(self.apiMedia, _formData, { headers: headers })
            .toPromise()
            .then((res: any) => res)
            .catch(error => {
                this.materialService.openSnackBar('Erreur dans la création d\'un média', 'red');
                console.error('error post Media service', error);
            })
    }

    postStoredMedia(file, params): Promise<ExerciceMedia> {
        const self = this;
        const _formData = new FormData();
        _formData.append('enctype', 'multipart/form-data');
        self.headers.delete('Content-Type');
        _formData.append('source', file);
        _formData.append('title', file.name);
        _formData.append('media_type', params.media_type);
        _formData.append('source_type', params.source_type);
        _formData.append('content_type', params.content_type);
        _formData.append('object_id', params.object_id);

        const headers = this.createHttpClientAuthorizationHeaderNoEnctype();
        return self._http.post(self.apiMedia, _formData, { headers: headers })
            .toPromise()
            .then((res: any) => res)
            .catch(error => {
                this.materialService.openSnackBar('Erreur dans la création d\'un média', 'red');
                console.error('error post Media service', error);
            })
    }
}
